import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Text, Notification, Loader, Title, Container, ContentSmall, List, i18n, tokens } from '@simplybenefits/sb-ui-library';
import { removeNotification } from '../../actions/user.js';

class Notifications extends PureComponent {
    _removeNotification = (notification) => {
        this.props.dispatch(removeNotification(notification.id));
    };

    render() {
        const { whitelabel } = this.props;

        if (!this.props.notifications) {
            return <Loader whitelabel={ whitelabel } noGif />;
        }

        return (
            <Container>
                <ContentSmall style={{ width: "75%" }}>
                    <Title title={ i18n.t(tokens.titles.notifications) } customStyle={{ marginBottom: this.props.notifications.length === 0 && -55, marginLeft: 110 }}/>
                   
                    <List style={{ marginLeft: 30, marginRight: 30 }}>
                        {
                            this.props.notifications.map((notification) => (
                                <Notification key={notification.id} notification={notification} onClick={ () => this._removeNotification(notification) } />
                            ))
                        }
                    </List>

                    {
                        this.props.notifications.length === 0 &&
                            <Text light medium customStyle={{ marginLeft: 110 }}>{ i18n.t(tokens.labels.account.youHaveNoNotifications) }</Text>
                    }
                </ContentSmall>

                <span id="notifications" />
            </Container>
        );
    }
}

Notifications.propTypes = {
    loading: PropTypes.bool,
    notifications: PropTypes.array,
    whitelabel: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.user.loading,
    notifications: state.user.notifications,
    whitelabel: state.whitelabel
});

export default connect(mapStateToProps)(Notifications);